module.exports = __webpack_public_path__ + "static/fabric-datepicker-weeknumber-c7c3a76f85b93ba781fc90e6bd5fae2f.png";